<template>
    <div>
        <div class="card_container">
            <div class="card_left">
                <img :src="cardItemInfo.cover_img" />
            </div>
            <div class="card_right">
                <div class="card_right_title">
                    {{ cardItemInfo.title || '--' }}
                </div>
                <div class="card_right_subtitle">
                    {{ cardItemInfo.sub_title || '--' }}
                </div>
            </div>
          
        </div>
    </div>
    <div class="m_desc" style="margin-top: 5px;">
        <div class="m_color_2">
            【{{ cardItemInfo.sub_type_str }}】
        </div>
        名片备注：{{cardItemInfo.memo}} 
    </div>

</template>

<script>
import { reactive, ref, onMounted, nextTick, computed } from 'vue';


export default {
    props: {
        cardItem: {
            type: Object,
            default: () => {
                return {}
            },
        }
    },
    setup(props) {
        const cover_img = 'https://s-m.lm12301.com/img/wexincard.jpg'

        const cardItemInfo = computed(() => {
            return props.cardItem
        })
        return {
            cover_img,
            cardItemInfo,
        }
    }
}

</script>
<style lang="less" scoped></style>